import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    accordionSummary: {
      flexDirection: 'row-reverse',
      minWidth: 0,
      // maxWidth: '100%',
      maxWidth: '65vw',
      justifyContent: 'space-between',
    },
    customAccordionSummaryContent: {
      overflow: 'hidden',
      justifyContent: 'space-between',
      minWidth: 0,
      textOverflow: "ellipsis",

      // width: '100%'
    },
    accordionHeader: { flexGrow: 0, minWidth: '100px !important' },
    accordionCenterColumn: { marginLeft: theme.spacing(1), flexGrow: 1, minWidth: 0, width: '80%', maxWidth: '80%', overflow: 'hidden', textOverflow: "ellipsis" },
    accordionLastColumn: { marginLeft: theme.spacing(2), marginRight: theme.spacing(3), minWidth: '163px', width: '20%', alignSelf: 'flex-end', flexGrow: 1, flexShrink: 1 },
    accordionColumn: {},
    accordionHeading: { fontSize: theme.typography.pxToRem(15) },
    accordionDetails: { alignItems: 'center', width: '100%' },
    accordionMain: { width: '100%' }
  })